import React from 'react'
import {AdminHomeWrapper} from './adminHome.constants'
export default function AdminHome({ match }) {



    return (
        <>
            <AdminHomeWrapper match={match}/>

        </>
    )
}


